<template>
	<div class="container">
		<p>筛选查询</p>
		<div class="container crumbs">
			<div class="handle-search">
				<e-search :data="formData" :field-list="fieldList" :list-type-info="listTypeInfo" :btnStyle="btnStyle"
					@handleReset="handleClear" @handleFilter="handleQuery"></e-search>
			</div>
		</div>
		<p>日志列表</p>
		<div class="container crumbs">
			<TableList :loading="loading" :table-data="tableData" :table-label="tableLabel" :table-option="tableOption"
				@handleButton="handleButton" @handleSortChange="handleSortChange"
				@handleSelectionChange="handleSelectionChange"></TableList>
			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="page.pageNum"
					:page-sizes="[10, 20, 50, 100, 200]" :page-size="page.pageSize" :total="pageTotal"
					@current-change="handlePageChange" @size-change="handleSizeChange" prev-text="上一页" next-text="下一页"
				></el-pagination>
			</div>

			<el-dialog title="详情内容" :visible.sync="dialogVisible" width="30%">
				<el-form label-width="100px" :model="particulars">
					<el-form-item label="事件:">
						<el-input v-model="particulars.operateType"></el-input>
					</el-form-item>
					<el-form-item label="操作人:">
						<el-input v-model="particulars.memberName"></el-input>
					</el-form-item>
					<el-form-item label="操作时间:">
						<el-input v-model="particulars.logTime"></el-input>
					</el-form-item>
					<el-form-item label="单据类型:">
						<el-input v-model="particulars.modular"></el-input>
					</el-form-item>
					<el-form-item label="单据编号:">
						<el-input v-model="particulars.keyMessage"></el-input>
					</el-form-item>
					<el-form-item label="IP地址:">
						<el-input v-model="particulars.memberIp"></el-input>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import ESearch from "../../components/common/e-search";
	import TableList from "../../components/common/e-table-list";
	import api from "../../api/logsystem/index";
	export default {
		//   name: "productCatalogExam",
		components: {
			ESearch,
			TableList
		},
		data() {
			return {
				particulars: {
					operateTypel: "",
					memberName: "",
					logTime: "",
					modular: "",
					keyMessage: "",
					memberIp:""
				},
				dialogVisible: false,
				loading: false,
				tableData: [],
				tableLabel: [{
						label: "序号",
						param: "index",
						align: "center",
						width: "100"
					},
					{
						label: "事件",
						param: "operateType",
						align: "center",
						width: "100"
					},
					{
						label: "操作人",
						param: "memberName",
						align: "center"
					},
					{
						label: "操作时间",
						param: "logTime",
						align: "center"
					},
					{
						label: "单据类型",
						param: "modular",
						align: "center"
					},
					{
						label: "单据编号",
						param: "keyMessage",
						align: "center"
					},
					{
						label: "IP地址",
						param: "memberIp",
						align: "center"
					},
					// { label: "操作类型", param: "logType", align: "center", render:(row)=>{
					//     if(row.logType === "ADD"){
					//         return "新增人员"
					//     }else if(row.logType =="MODIFY"){
					//         return "修改人员"
					//     }else if(row.logType =="DELETE"){
					//         return "删除人员"
					//     }
					// }},
					// { label: "角色名称", param: "roleName", align: "center"},
					// { label: "权限名称", param: "authName", align: "center"},
				],
				tableOption: {
					label: "操作",
					width: "300",
					fixed: "right",
					permission: '0',
					options: [{
						label: "查看详情",
						type: "primary",
						methods: "handleButton"
					}, ],
					flag: true,
				},
				fieldList: [{
						label: "事件",
						type: "select",
						value: "supplierCompanyName",
						list: "applicationStatus",
					},
					{
						label: "操作人",
						type: "input",
						value: "applicationStatus"
					},
					{
						label: "操作时间",
						type: "date",
						value: "startTime",
						dateType: "daterange",
					},
					{
						label: "单据编号",
						type: "input",
						value: "CharacterName"
					},
					{
						label: "单据类型",
						type: "select",
						value: "jurisdiction",
						list: "receipts",
					},
					{
						label: 'IP地址',
						type: 'input',
						value: 'memberIp'
					},
				],
				listTypeInfo: {
					applicationStatus: [{
							id: "1",
							name: "订单下达"
						},
						{
							id: "2",
							name: "供应商确认"
						},
						{
							id: "3",
							name: "采购商确认"
						},
						{
							id: "4",
							name: "订单审批"
						},
						{
							id: "5",
							name: "订单变更"
						},
						{
							id: "6",
							name: "变更确认"
						},
						{
							id: "7",
							name: "订单付款"
						},
						{
							id: "8",
							name: "订单发货"
						},
						{
							id: "9",
							name: "订单收货"
						},
						{
							id: "10",
							name: "订单评价"
						},
						{
							id: "11",
							name: "订单售后"
						},
						{
							id: "12",
							name: "售后确认"
						},
					],
					receipts: [{
							id: "1",
							name: "全部类型"
						},
						{
							id: "2",
							name: "交易订单"
						},
						{
							id: "3",
							name: "售后订单"
						},
					],
				},
				btnStyle: [{
						icon: "el-icon-refresh",
						text: "重置"
					},
					{
						icon: "el-icon-search",
						text: "查询",
						type: "primary"
					},
				],
				pageTotal: 0,
				formData: {
					supplierCompanyName: "",
					startTime: "",
					applicationStatus: "",
					CharacterName: "",
					jurisdiction: "",
					memberIp: ""
				},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
			};
		},
		created() {
			this.AccessAoThePaging();
		},
		methods: {
			// handleSearch() {
			//    this.formData.pageNum = 10
			//  },
			//重置
			handleClear() {
				// this.formData.supplierCompanyName=""
				// this.formData.applicationStatus=""
				// this.formData.startTime=""
				// this.formData.loginID=""
				// this.formData.cellPhoneNumber=""
				// this.formData.emailAddress=""
				this.AccessAoThePaging();
			},
			//查询
			handleQuery(val) {
				console.log(val);
				let Query = {
					operateType: val.supplierCompanyName,
					memberName: val.applicationStatus,
					logStart: val.startTime[0],
					logEnd: val.startTime[1],
					keyMessage: val.CharacterName,
					pageSize: this.page.pageSize,
					pageNum: this.page.pageNum,
					modular: val.jurisdiction,
					memberIp:val.memberIp
				};
				api.queryLogListByPage(Query).then((res) => {
					console.log(res);
					if (res.code == "200") {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					}
				});
			},
			//查看详情
			handleButton(val) {
				console.log(val);
				this.dialogVisible = true
				this.particulars.operateType = val.row.operateType
				this.particulars.memberName = val.row.memberName
				this.particulars.logTime = val.row.logTime
				this.particulars.modular = val.row.modular
				this.particulars.keyMessage = val.row.keyMessage
				this.particulars.memberIp = val.row.memberIp
			},
			handleSortChange() {},
			handleSelectionChange() {},
			//分页导航
			handlePageChange(val) {
				this.page.pageNum = val;
				this.AccessAoThePaging();
			},
			handleSizeChange(pageSize) {
				console.log(pageSize);
				this.page.pageSize = pageSize;
				this.AccessAoThePaging();
			},
			async AccessAoThePaging() {
				let res = await api.queryLogListByPage(this.page);
				console.log(res);
				if (res.code == "200") {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.time {
		::v-deep .el-input {
			width: 80px;
		}
	}
</style>
